import { LineMask, FadeUp } from "@/components/Reveal";
import ContactForm from "@/components/ContactForm";
import Magnetic from "@/components/Magnetic";
import { ArrowRight } from "lucide-react";

const ContactSection = () => (
  <section id="kontakt" data-testid="contact" className="shell py-28 md:py-44 border-t hairline" aria-label="Kontakt">
    <h2 className="font-display font-semibold uppercase tracking-tight leading-[0.92] text-[13vw] sm:text-[10vw] lg:text-[7.5vw] 2xl:text-[7.5rem] text-paper" data-testid="contact-headline">
      <LineMask>Hast du</LineMask>
      <LineMask delay={0.12}><span className="text-gold">was vor?</span></LineMask>
    </h2>

    <FadeUp delay={0.2}>
      <p className="mt-6 label-text text-paper/70">Film · Audio · Agentur</p>
    </FadeUp>

    <FadeUp delay={0.25}>
      <p className="mt-8 text-lg md:text-2xl text-paper/85 max-w-lg leading-snug">Lass uns darüber sprechen.</p>
    </FadeUp>

    <FadeUp delay={0.35} className="mt-10">
      <Magnetic>
        <a
          href="mailto:info@dimedial.de?subject=Projektanfrage"
          data-testid="contact-cta"
          className="inline-flex items-center gap-4 border border-paper/30 hover:border-gold px-8 md:px-10 py-4 md:py-5 text-sm md:text-base font-semibold uppercase tracking-[0.22em] text-paper hover:text-gold transition-[border-color,color] duration-500"
        >
          Projekt starten
          <ArrowRight size={18} />
        </a>
      </Magnetic>
    </FadeUp>

    <div className="mt-20 md:mt-32 grid grid-cols-1 lg:grid-cols-12 gap-14 lg:gap-20">
      <FadeUp className="lg:col-span-5">
        <div className="space-y-10">
          <div>
            <p className="label-text mb-3">Direkt</p>
            <a data-testid="contact-email" href="mailto:info@dimedial.de" className="block font-display text-2xl md:text-3xl text-paper hover:text-gold transition-colors duration-500 tracking-wide">info@dimedial.de</a>
            <a data-testid="contact-phone-1" href="tel:+4952211412070" className="block mt-3 text-lg text-grey hover:text-paper transition-colors duration-500">05221-1412070</a>
          </div>
          <div>
            <p className="label-text mb-3">Studio</p>
            <address className="not-italic text-lg text-grey leading-relaxed" data-testid="contact-address">
              DIMEDIAL<br />
              Mindener Str. 52<br />
              32049 Herford
            </address>
          </div>
        </div>
      </FadeUp>
      <FadeUp delay={0.15} className="lg:col-span-7">
        <ContactForm />
      </FadeUp>
    </div>
  </section>
);

export default ContactSection;
